export const STATUS_ENUM = {
  ACTIVE: 'active',
  ARCHIVED: 'archived'
};

export const CHANNELS = [
  'Email',
  'SMS',
  'In-Voice',
  'Voice',
  'Push'
];

export const FILTER_OPTIONS = {
  TRIGGER: [
    'Email opened',
    'SMS delivered',
    'Push notification clicked',
    'Campaign completed',
    'Form submitted',
    'Purchase made',
    'Cart abandoned',
    'Website visited',
    'App installed',
    'Subscription started'
  ],
  AUDIENCE: [
    'New customers',
    'Loyal customers',
    'High-value clients',
    'Inactive users',
    'Newsletter subscribers',
    'Mobile app users',
    'Website visitors',
    'Cart abandoners',
    'Previous buyers',
    'Premium members'
  ],
  STATUS: [
    'Active',
    'Archived'
  ],
  PERIOD: [
    '24 hours',
    '48 hours',
    '72 hours',
    '1 week',
    '2 weeks',
    '1 month',
    '3 months',
    '6 months'
  ]
};

export const MOCK_DATA = [
  {
    id: 'rule_001',
    name: 'Post-Purchase Follow-up Limit',
    trigger: 'Purchase made',
    contacts: '2,547',
    status: STATUS_ENUM.ACTIVE,
    period: '48 hours',
    channels: ['Email', 'SMS', 'Push'],
    created_at: '2024-03-15'
  },
  {
    id: 'rule_002',
    name: 'Newsletter Frequency Cap',
    trigger: 'Email opened',
    contacts: '15,890',
    status: STATUS_ENUM.ACTIVE,
    period: '1 week',
    channels: ['Email'],
    created_at: '2024-03-14'
  },
  {
    id: 'rule_003',
    name: 'Cart Abandonment Recovery',
    trigger: 'Cart abandoned',
    contacts: '1,203',
    status: STATUS_ENUM.ARCHIVED,
    period: '24 hours',
    channels: ['Email', 'Push', 'SMS', 'In-Voice'],
    created_at: '2024-03-13'
  },
  {
    id: 'rule_004',
    name: 'App Engagement Limit',
    trigger: 'Push notification clicked',
    contacts: '8,756',
    status: STATUS_ENUM.ACTIVE,
    period: '72 hours',
    channels: ['Push', 'In-App'],
    created_at: '2024-03-12'
  },
  {
    id: 'rule_005',
    name: 'Premium Member Communications',
    trigger: 'Subscription started',
    contacts: '456',
    status: STATUS_ENUM.ACTIVE,
    period: '1 month',
    channels: ['Email', 'SMS', 'Direct Mail'],
    created_at: '2024-03-11'
  },
  {
    id: 'rule_006',
    name: 'Website Retargeting Control',
    trigger: 'Website visited',
    contacts: '23,145',
    status: STATUS_ENUM.ACTIVE,
    period: '2 weeks',
    channels: ['Display Ads', 'Email'],
    created_at: '2024-03-10'
  },
  {
    id: 'rule_007',
    name: 'Mobile App Install Campaign',
    trigger: 'App installed',
    contacts: '3,678',
    status: STATUS_ENUM.ARCHIVED,
    period: '1 week',
    channels: ['Push', 'In-App', 'Email'],
    created_at: '2024-03-09'
  },
  {
    id: 'rule_008',
    name: 'Lead Form Response Limit',
    trigger: 'Form submitted',
    contacts: '892',
    status: STATUS_ENUM.ACTIVE,
    period: '24 hours',
    channels: ['Email', 'SMS'],
    created_at: '2024-03-08'
  },
  {
    id: 'rule_009',
    name: 'SMS Campaign Frequency',
    trigger: 'SMS delivered',
    contacts: '5,234',
    status: STATUS_ENUM.ACTIVE,
    period: '72 hours',
    channels: ['SMS', 'In-Voice'],
    created_at: '2024-03-07'
  },
  {
    id: 'rule_010',
    name: 'Campaign Completion Follow-up',
    trigger: 'Campaign completed',
    contacts: '12,567',
    status: STATUS_ENUM.ACTIVE,
    period: '1 month',
    channels: ['Email', 'Survey', 'Direct Mail'],
    created_at: '2024-03-06'
  }
]; 